import React from 'react';
export function useFlux(initialState) {
  const [state, setState] = React.useState(initialState);
  const mutate = React.useCallback(mutation => setState(s => mutation(s)), [setState]);
  const query = React.useCallback(q => q(state), [state]);
  return [state, mutate, query];
}